// Two Signature of top is not correct
import { firestore } from '@/utils/firebase';
// TODO: This is the dummy data for the risks, it should be replaced with the real data (By querying the backend)
// query the document and get the data
// firebase db
// get the signature configurations from firestore

const getSignatureNameFromKey = key => {
  switch (key) {
    case 'authentications':
      return 'Authentications';
    case 'dataAtRisk':
      return 'Data At Risk';
    case 'iamMisconfigurations':
      return 'IAM Misconfigurations';
    case 'lateralMovement':
      return 'Lateral Movement';
    case 'malware':
      return 'Malware';
    case 'neglectedAssets':
      return 'Neglected Assets';
    case 'osVulnerabilities':
      return 'OS Vulnerabilities';

    default:
      return 'Vulnerabilities';
  }
};

export const getSignatureConfigurations = async () => {
  try {
    const signatureConfigurations = await firestore
      .collection('Global')
      .doc('signatureCategories')
      .get();
    const _categories = signatureConfigurations.data().categories;
    // modify this to the correct format with Map
    const categories = new Map();
    Object.keys(_categories).forEach(key => {
      _categories[key].forEach(item => {
        categories.set(item, getSignatureNameFromKey(key));
      });
    });
    return categories;
  } catch (error) {
    console.log('error in getting signature configurations: ', error);
    return [];
  }
};

export const awsData = new Map([
  ['AWS:EC2-026', 'Neglected Assets'],
  ['AWS:EC2-012', 'Neglected Assets'],
  ['AWS:CF-001', 'Data At Risk'],
  ['AWS:CF-002', 'Vulnerabilities'],
  ['AWS:CF-003', 'Data At Risk'],
  ['AWS:CLT-001', 'Vulnerabilities'],
  ['AWS:CLT-002', 'Vulnerabilities'],
  ['AWS:CLT-003', 'Neglected Assets'],
  ['AWS:CLT-006', 'Neglected Assets'],
  ['AWS:CLT-007', 'Vulnerabilities'],
  ['AWS:CONFIG-002', 'Vulnerabilities'],
  ['AWS:CONFIG-001', 'Vulnerabilities'],
  ['AWS:CONFIG-003', 'Vulnerabilities'],
  ['AWS:CONFIG-004', 'Authentications'],
  ['AWS:CWALM-001', 'Vulnerabilities'],
  ['AWS:CWALM-002', 'Vulnerabilities'],
  ['AWS:LAMBDA-001', 'Neglected Assets'],
  ['AWS:LAMBDA-002', 'Neglected Assets'],
  ['AWS:LAMBDA-003', 'Neglected Assets'],
  ['AWS:DDB-001', 'Data at Risk'],
  ['AWS:DDB-002', 'Lateral Movement'],
  ['AWS:DDB-003', 'Neglected Assets'],
  ['AWS:EC2-005', 'Neglected Assets'],
  ['AWS:EC2-008', 'Data at Risk'],
  ['AWS:EC2-009', 'Neglected Assets'],
  ['AWS:EC2-021', 'Vulnerabilities'],
  ['AWS:EC2-022', 'Lateral Movement'],
  ['AWS:EC2-025', 'Neglected Assets'],
  ['AWS:EBS-001', 'Data at Risk'],
  ['AWS:EBS-002', 'Vulnerabilities'],
  ['AWS:EBS-003', 'Vulnerabilities'],
  ['AWS:EBS-007', 'Lateral Movement'],
  ['AWS:ELB-001', 'Vulnerabilities'],
  ['AWS:ELB-012', 'Data at Risk'],
  ['AWS:ELB-013', 'Data at Risk'],
  ['AWS:ELB-014', 'Data at Risk'],
  ['AWS:EIP-001', 'Neglected Assets'],
  ['AWS:EIP-002', 'Neglected Assets'],
  ['AWS:IAM-006', 'IAM Misconfigurations'],
  ['AWS:IAM-007', 'Authentications'],
  ['AWS:IAM-010', 'IAM Misconfigurations'],
  ['AWS:IAM-013', 'IAM Misconfigurations'],
  ['AWS:IAM-014', 'IAM Misconfigurations'],
  ['AWS:IAM-015', 'IAM Misconfigurations'],
  ['AWS:IAM-016', 'IAM Misconfigurations'],
  ['AWS:IAM-018', 'Authentications'],
  ['AWS:IAM-020', 'IAM Misconfigurations'],
  ['AWS:IAM-021', 'IAM Misconfigurations'],
  ['AWS:KMS-005', 'Neglected Assets'],
  ['AWS:RDS-006', 'Vulnerabilities'],
  ['AWS:RDS-002', 'Data at Risk'],
  ['AWS:RDS-005', 'Vulnerabilities'],
  ['AWS:S3-005', 'IAM Misconfigurations'],
  ['AWS:RDS-007', 'Vulnerabilities'],
  ['AWS:RDS-009', 'Vulnerabilities'],
  ['AWS:RDS-010', 'Vulnerabilities'],
  ['AWS:RDS-012', 'Data at Risk'],
  ['AWS:S3-007', 'Neglected Assets'],
  ['AWS:S3-001', 'Data at Risk'],
  ['AWS:S3-008', 'Neglected Assets'],
  ['AWS:S3-006', 'Vulnerabilities'],
  ['AWS:S3-009', 'Neglected Assets'],
  ['AWS:S3-010', 'Neglected Assets'],
  ['AWS:VPC-021', 'Vulnerabilities'],
  ['AWS:VPC-024', 'Vulnerabilities'],
  ['AWS:VPC-026', 'Vulnerabilities'],
  ['AWS:S3-011', 'Data at Risk'],
  ['AWS:S3-012', 'Data at Risk'],
  ['AWS:S3-014', 'Neglected Assets'],
  ['AWS:S3-016', 'Vulnerabilities'],
  ['AWS:VPC-002', 'Neglected Assets'],
  ['AWS:NSG-001', 'Authentications'],
  ['AWS:NSG-002', 'Authentications'],
  ['AWS:NSG-003', 'Authentications'],
  ['AWS:NSG-004', 'Neglected Assets'],
  ['AWS:NSG-005', 'Neglected Assets'],
  ['AWS:NSG-006', 'Neglected Assets'],
  ['AWS:SNAP-003', 'Neglected Assets'],
  ['AWS:ECS-001', 'Vulnerabilities'],
  ['AWS:ECR-001', 'Neglected Assets'],
  ['AWS:ECR-002', 'Vulnerabilities'],
  ['AWS:EKS-001', 'Authentications'],
  ['AWS:EKS-002', 'Vulnerabilities'],
  ['AWS:EKS-003', 'Vulnerabilities'],
  ['AWS:EKS-004', 'Data at Risk'],
  ['AWS:API-001', 'Vulnerabilities'],
  ['AWS:API-002', 'Vulnerabilities'],
  ['AWS:API-003', 'Vulnerabilities'],
  ['AWS:GLUE-001', 'Data at Risk'],
  ['AWS:GLUE-002', 'Data at Risk'],
  ['AWS:NSG-007', 'Neglected Assets'],
  ['AWS:IAM-023', 'IAM Misconfigurations'],
]);
